<div class="nx-margin-bottom-3m u-text-center">
  <h1 nxHeadline="subsection-small" class="nx-font-weight-light">{{ header | translate }}</h1>
</div>
